module.exports = __webpack_public_path__ + "img/nt117-00-81-1.asm.85d2e0b2.jpg";